import React from 'react';

export const DisabilityAssessmentInfo = () => (
  <>
    <div className="partly-disabled-info">
      <h4>Beroepsarbeid</h4>
      <p>Er wordt beoordeeld of u uw beroep nog uit kunt oefenen. Kunt u dat niet? Dan bent u arbeidsongeschikt, ongeacht of u nog andere beroepen of
        werkzaamheden kunt verrichten (voor sommige fysiek zware en creatieve beroepen gelden uitsluitingen of beperkingen voor het verzekeren van beroepsarbeid).
      </p>
    </div>
    <div className="partly-disabled-info">
      <h4>Passende arbeid</h4>
      <p>Er wordt beoordeeld of u in combinatie met uw beperkingen, opleidingsniveau en vroegere werkzaamheden, nog andere functies kunt uitvoeren.
      </p>
    </div>
    <div className="partly-disabled-info">
      <h4>Gangbare arbeid</h4>
      <p>Er wordt beoordeeld of u in algemene zin nog werk kunt verrichten. Er wordt geen rekening gehouden met uw beroep, opleidingsniveau of vroegere werkzaamheden.</p>
    </div>
  </>
);
